import { SortOrder, MONTHS } from '../constants'

const VIEW_MODES = {
  POWER: 'power',
  ENERGY: 'energy',
}

const POWER_LABEL = 'Avg Discharge Power (W)'
const ENERGY_LABEL = 'Total Discharge Energy (Wh)'

const POWER_MAP_KEY = 'avgDischargePowerMap'
const ENERGY_MAP_KEY = 'totalDischargeEnergyMap'

const POWER_TOTAL_KEY = 'totalWatt'
const ENERGY_TOTAL_KEY = 'totalWh'

const POWER_UNIT = 'W'
const ENERGY_UNIT = 'Wh'

const POWER_UNIT_LABEL = 'kW'
const ENERGY_UNIT_LABEL = 'kWh'

const REQUEST_BODY_PLACEHOLDER = `{
  "programkey": "Enphase Test",
  "startDate": "2025-06-01",
  "endDate": "2025-09-30"
}`

const YEARLY_REQUEST_BODY_PLACEHOLDER = `{
  "programkey": "Enphase Test",
  "year": 2025
}`

const PAGE_TITLE = 'Site Daily Discharge Viewer'

const CSV_HEADERS = {
  SITE_ID: 'Site ID',
  PROGRAM_KEY: 'Program Key',
}

const CSV_FILE_PREFIX = 'site-discharge'

const GRAND_TOTAL_LABEL = 'Grand Total'

const TOTAL_COLOR_POWER = '#166534'
const TOTAL_COLOR_ENERGY = '#6d28d9'

const DISCHARGE_EMPTY_TABLE_TEXT = 'No data available. Enter filter criteria and click Fetch & Render.'

export {
  SortOrder,
  MONTHS,
  VIEW_MODES,
  POWER_LABEL,
  ENERGY_LABEL,
  POWER_MAP_KEY,
  ENERGY_MAP_KEY,
  POWER_TOTAL_KEY,
  ENERGY_TOTAL_KEY,
  POWER_UNIT,
  ENERGY_UNIT,
  POWER_UNIT_LABEL,
  ENERGY_UNIT_LABEL,
  REQUEST_BODY_PLACEHOLDER,
  YEARLY_REQUEST_BODY_PLACEHOLDER,
  PAGE_TITLE,
  CSV_HEADERS,
  CSV_FILE_PREFIX,
  GRAND_TOTAL_LABEL,
  TOTAL_COLOR_POWER,
  TOTAL_COLOR_ENERGY,
  DISCHARGE_EMPTY_TABLE_TEXT,
}
